$(document).ready(function () {
    $('a.btn.portal-notification-dismiss').on('click', function (event) {
        event.preventDefault();
        $.get($(this).attr('href'), function () {
            window.parent.$('.modal').modal('hide');
        });
    });
    $('a[data-toggle="iframe"].portal-notification').each(function () {
        $(this).get(0).click();
    });
});